import React from 'react';
import { whyTrustUsPropTypes } from './WhyTrustUsPropTypes';
import Text from '@Theme/natucare/components/Tooltip/components/Text/Text';
import Hr from '@Theme/natucare/components/Tooltip/components/Hr/Hr';
const WhyTrustUs = ({
  text,
  footerText
}) => {
  if (!text && !footerText) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    html: text
  }), footerText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hr, null), /*#__PURE__*/React.createElement(Text, {
    html: footerText
  })));
};
export default WhyTrustUs;